import WithMaintenance from "@insightfulscience/smart-react/hocs/WithMaintenance";

import { serviceCore } from "../services";
import Maintenance from "./Maintenance";

export default WithMaintenance({
	MaintenanceComp: Maintenance,
	serviceCore,
});
